import styled, { keyframes } from 'styled-components';

export const ProgressContent = styled.div`
  flex: 1;
  width: 100%;
  height: 10px;
  left: 0px;
  top: 0px;
  position: fixed;
  z-index: 4000;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
`;

const ProgressIcAnimation = keyframes`  
  0% { width: 0px; }
  100% { width: 92%; }
`;

export const ProgressIc = styled.div`
  float: left;
  width: 92%;
  height: 100%;
  background: ${({ theme }) => theme.colors.ORANGE};
  animation-name: ${ProgressIcAnimation};
  animation-duration: 10s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-play-state: running;
`;
